'use strict';

var cache = {};
var expressPayPal = require('@int_radial_SFRA/js/cart/paypalExpress');

function addAccessibilityToAppleCTA($cta) {
    if ($cta.length === 0) {
        return;
    }
    var accessibilityData = $cta.closest('.js-apple-pay-accessibility').length > 0 ? $cta.closest('.js-apple-pay-accessibility')[0].dataset : '';

    $cta.html(accessibilityData ? `<span class="sr-only">${accessibilityData.ctaContent}</span>` : '');
}

function applePayObserver() {
    if (!window.ApplePaySession) {
        return;
    }

    var observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if ($(mutation.addedNodes).hasClass('dw-apple-pay-button')) {
                var $applePayCTA = $(mutation.addedNodes);
                cache.$document.trigger('applePayInjected', $applePayCTA);
                addAccessibilityToAppleCTA($applePayCTA);
                observer.disconnect();
            }
        });
    });
    observer.observe(document, {attributes: false, childList: true, characterData: false, subtree:true});
}

module.exports = {
    initCache: function () {
        cache.baseObj = this;
        cache.const = {
            'DW_APPLE_PAY': 'DW_APPLE_PAY'
        };
        cache.$document = $(document);
        cache.$expressCheckout = $('.js-express-checkout');
        cache.$expressCheckoutLbl = cache.$expressCheckout.find('.js-express-label');
        cache.haveApplePayBtn = typeof window.ApplePaySession === 'function';
        cache.havePayPal = cache.$expressCheckout.data('pay-pal');
        cache.applePaytagInitialized = cache.$expressCheckout.find('isapplepay').length === 0;
        cache.haveExpressCheckout = (cache.haveApplePayBtn && cache.applePaytagInitialized) || cache.havePayPal;
        cache.$expressCheckout.attr('data-apple-pay', !!cache.haveApplePayBtn);
        cache.$applePayCTA = $('.dw-apple-pay-button');
        cache.$applePayTab = cache.$expressCheckout.find('.nav-item[data-method-id="' + cache.const.DW_APPLE_PAY + '"]');
    },
    toggleExpressCheckoutLabel: function () {
        if (cache.$expressCheckoutLbl.length === 0) {
            return;
        }

        if (cache.haveExpressCheckout) {
            cache.$expressCheckoutLbl.removeClass('d-none');
        }
    },
    toggleCheckoutApplePayMethod: function () {
        if (cache.$applePayTab.length === 0) {
            return;
        }

        if (cache.haveExpressCheckout) {
            cache.$applePayTab.removeClass('d-none');
        }
    },
    applePayEvents: function () {
        if (window.ApplePaySession) {
            cache.$document.on('applePayInjected', () => {
                this.initCache();
                this.toggleExpressCheckoutLabel();
                this.toggleCheckoutApplePayMethod();
                expressPayPal.paypalExpress();
            });

            applePayObserver();
            addAccessibilityToAppleCTA(cache.$applePayCTA);
        }

        cache.$document.on('miniCart:open', () => {
            this.initCache();
            applePayObserver();
            this.toggleExpressCheckoutLabel();
            expressPayPal.paypalExpress();

            $('[data-cbt-begin-checkout-minicart]').each(function () {
                var $this = $(this);
                $this.on('click', function () {
                    var cbtData = $this.data('cbt-begin-checkout-minicart');
                    if (cbtData) {
                        window.dataLayer.push(cbtData);
                    }
                });
            });
        });
    }
};
